const ReservationStatus = Object.freeze({
    BOOKED: 'BOOKED',
    SENT: 'SENT',
    CANCELLED: 'CANCELLED',
});

export {ReservationStatus};